import axios, { getStandardAxiosConfig } from '../../util/api';

class UltrasoundAPI {
  static fetchUltrasoundScans () {
    return axios.get(
      '/ultrasound', getStandardAxiosConfig()
    );
  }
  static uploadSession (technician, file, onProgress) {
    const formData = new window.FormData();
    formData.append('file', file);
    const config = getStandardAxiosConfig();
    config.headers['Content-Type'] = 'multipart/form-data';
    config.onUploadProgress = onProgress;
    const url =
    '/ultrasound/cuplabs/csv?technician=' + technician;
    return axios.post(url, formData, config);
  }
}

export default UltrasoundAPI;
